import React, { useState, useEffect } from "react";
import { useGetAggregationFarmerStockQuery } from "./AggregationApiSlice";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  TextField,
  Box,
  CircularProgress,
  Alert,
  Button,
  Stack,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { useUpdateAggregationByFarmerMutation } from "./AggregationApiSlice";
import { toast } from "react-toastify";
import { Modal, Button as ButtonReactStrap } from "react-bootstrap";
import { faPenToSquare, faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AggregationAssignFarmer from "./AggregationAssignFarmer";
export const AggregationDetailView = ({
  aggrigationId,
  aggrigationDetails,
}) => {
  const {
    data: getDetails,
    refetch,
    isLoading,
    isError,
    error,
  } = useGetAggregationFarmerStockQuery(aggrigationId);
  const [updatedData, setUpdatedData] = useState({});
  const [updateFarmer] = useUpdateAggregationByFarmerMutation();
  const [addFarmer, setAddFarmer] = useState(false);

  if (isLoading)
    return (
      <Box textAlign="center" mt={4}>
        <CircularProgress />
      </Box>
    );

  if (isError)
    return (
      <Box mt={2}>
        <Alert severity="error">
          {error?.data?.message || "Failed to load data"}
        </Alert>
      </Box>
    );

  const handleChange = (index, field, value) => {
    setUpdatedData((prev) => ({
      ...prev,
      [index]: {
        ...getDetails.data[index], // original full object
        ...prev[index],
        [field]: value,
      },
    }));
  };
  const handleSubmit = (index) => {
    const original = getDetails.data[index];
    const updated = updatedData[index];

    if (!updated) return;

    const hasChanged =
      Number(original.quantity) !== Number(updated.quantity) ||
      Number(original.quoted_price) !== Number(updated.quoted_price);

    if (hasChanged) {
      const finalPayload = {
        ...original, // all original data
        quantity: updated.quantity, // updated fields only
        quoted_price: updated.quoted_price,
      };

      updateFarmer({ id: finalPayload.id, payload: finalPayload })
        .unwrap()
        .then((data) => {
          toast.success("Farmer stock updated successfully");
          refetch();
        })
        .catch((error) => {
          toast.error("Failed to update stock");
        });
    } else {
      toast.info("No changes to update");
    }
  };

  return (
    <Box p={3}>
      {aggrigationDetails && (
        <Card
          variant="outlined"
          sx={{ mb: 5, borderRadius: 1, backgroundColor: "#e8faf8" }}
          className="mt-3"
        >
          <CardContent>
            <Grid container spacing={2}>
              {/* <Grid item xs={12} sm={6} md={3}>
          <Typography variant="body1" fontWeight={500}>
            FPO:
          </Typography>
          <Typography variant="body2" color="primary">
            {aggrigationDetails.fpo_name || 'N/A'}
          </Typography>
        </Grid> */}

              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="body1" fontWeight={500}>
                  Crop :
                </Typography>
                <Typography variant="body2" color="success.main">
                  {aggrigationDetails.crop_name || "N/A"}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="body1" fontWeight={500}>
                  Stock Status :
                </Typography>
                <Typography variant="body2" color="success.main">
                  {aggrigationDetails.stock_status}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="body1" fontWeight={500}>
                  Total Quantity :
                </Typography>
                <Typography variant="body2">
                  {aggrigationDetails.total_quantity}{" "}
                  <span style={{ color: "#555" }}>
                    {aggrigationDetails.unit_measurement}
                  </span>
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="body1" fontWeight={500}>
                  Season :
                </Typography>
                {aggrigationDetails.season}
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="body1" fontWeight={500}>
                  Year :
                </Typography>
                {aggrigationDetails.year}
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="body1" fontWeight={500} gutterBottom>
                  Created On :
                </Typography>
                <Stack direction="row" spacing={1} alignItems="center">
                  <CalendarTodayIcon fontSize="small" color="action" />
                  <Typography variant="body2" color="text.secondary">
                    {aggrigationDetails.created_at
                      ? new Date(
                          aggrigationDetails.created_at
                        ).toLocaleDateString()
                      : "N/A"}
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )}

      <div className="d-flex justify-content-between align-items-center mb-3">
        <Typography variant="h5" gutterBottom>
          Farmer Details
        </Typography>
        <div>
          <ButtonReactStrap
            id="AddLeads"
            className="buttonOrangeDefaultColor2"
            size="sm"
            onClick={() => setAddFarmer(true)}
          >
            Add Farmer&nbsp;
            <i className="mdi mdi-account-plus custom-btn-fs fs-6"></i>
          </ButtonReactStrap>
          <ButtonReactStrap
            className="bg-transparent text-black fs-6 reloadButton float-end"
            size="sm"
            onClick={() => {
              refetch();
            }}
          >
            <FontAwesomeIcon icon={faRotateLeft} />
          </ButtonReactStrap>
        </div>
      </div>

      {Array.isArray(getDetails?.data) && getDetails.data.length > 0 ? (
        <Grid container spacing={4}>
          {getDetails.data.map((stock, index) => (
            <Grid item xs={12} md={6} lg={4} key={index}>
              <Card
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  px: 2,
                  py: 2,
                  backgroundColor: "#f9f9f9",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                }}
              >
                <CardContent>
                  <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <PersonIcon fontSize="small" />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      {stock.farmer_name || "Unknown Farmer"}
                    </Typography>
                  </Stack>

                  <Typography variant="body2" color="text.secondary">
                    📞 {stock.farmer_mobile || "N/A"}
                  </Typography>

                  <Typography variant="body2" color="text.secondary" mt={0.5}>
                    🌾 Crop: <strong>{stock.crop_name || "N/A"}</strong>
                  </Typography>

                  <Stack direction="row" spacing={1} alignItems="center" mt={1}>
                    <CalendarTodayIcon fontSize="small" color="action" />
                    <Typography variant="caption" color="text.secondary">
                      Created on:{" "}
                      {stock.created_at
                        ? new Date(stock.created_at).toLocaleDateString()
                        : "N/A"}
                    </Typography>
                  </Stack>

                  <Grid container spacing={2} mt={2}>
                    <Grid item xs={6}>
                      <TextField
                        label="Quantity"
                        size="small"
                        fullWidth
                        style={{ backgroundColor: "white" }}
                        defaultValue={stock.quantity}
                        onChange={(e) =>
                          handleChange(index, "quantity", e.target.value)
                        }
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        label="Price (₹)"
                        size="small"
                        fullWidth
                        style={{ backgroundColor: "white" }}
                        defaultValue={stock.quoted_price}
                        onChange={(e) =>
                          handleChange(index, "quoted_price", e.target.value)
                        }
                      />
                    </Grid>
                  </Grid>

                  {/* Location */}
                  <Box mt={2}>
                    <Typography variant="caption" color="text.secondary">
                      📍 Location
                    </Typography>
                    <Typography variant="body2" fontWeight={500}>
                      {[
                        stock.village_name,
                        stock.block_name,
                        stock.district_name,
                        stock.state_name,
                      ]
                        .filter(Boolean)
                        .join(", ") || ""}
                    </Typography>
                  </Box>

                  <Box mt={1} display="flex" justifyContent="flex-end">
                    <Button
                      size="small"
                      variant="contained"
                      className="buttonOrangeDefaultColor"
                      onClick={() => handleSubmit(index)}
                      sx={{ textTransform: "none", borderRadius: 2 }}
                    >
                      Update
                    </Button>
                    {/* <Button
                              id="editDetails"
                              type=""
                              className="buttonOrangeDefaultColor"
                              onClick={() => handleSubmit()}
                              size="sm"
                            >
                              Update&nbsp; 
                            </Button> */}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography>No stock data found.</Typography>
      )}
      <Modal
        show={addFarmer}
        onHide={() => {
          setAddFarmer(false);
          localStorage.removeItem("selectedFarmers");
        }}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">Add Farmer</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "1.5rem" }}>
          <div>
            <AggregationAssignFarmer
              aggregationDetails={aggrigationDetails}
              setAddFarmer={setAddFarmer}
              refetchFarmers={refetch}
            />
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </Box>
  );
};
